var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none",
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    x: 0.5,
    y: 0.5,
    fill: "url(#a)",
    rx: 51.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    x: 0.5,
    y: 0.5,
    stroke: "url(#b)",
    rx: 51.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 40,
    height: 40,
    x: 32,
    y: 32,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72 32H32v40h40V32Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    d: "m45.46 44.1.158.139L59.761 58.38a1.66 1.66 0 0 1 .47 1.433 1.671 1.671 0 0 1-.88 1.226l-.193.083L41.85 67.5c-3.253 1.2-6.422-1.858-5.434-5.106l.084-.243 6.377-17.309a1.66 1.66 0 0 1 1.004-.995 1.67 1.67 0 0 1 1.407.135l.172.118Zm-.357 4.337-5.474 14.867a.832.832 0 0 0 .936 1.106l.133-.038 14.863-5.477-10.458-10.458Zm15.409 2.903c1.518.08 3.6.4 5.41 1.487a1.665 1.665 0 0 1-.31 3.01 1.669 1.669 0 0 1-1.232-.06l-.173-.092c-1.137-.683-2.59-.95-3.87-1.017a12.846 12.846 0 0 0-1.584.007l-.527.052a1.666 1.666 0 0 1-.468-3.3 14.323 14.323 0 0 1 2.754-.089m3.375-4.642a1.666 1.666 0 0 1 .193 3.321l-.193.011h-1.18a1.665 1.665 0 0 1-.194-3.32l.193-.012h1.18Zm-5.304-1.28a1.663 1.663 0 0 1 .138 2.2l-.138.157-1.767 1.769a1.663 1.663 0 0 1-2.285.078 1.667 1.667 0 0 1-.211-2.278l.138-.157 1.767-1.767a1.668 1.668 0 0 1 2.358-.001Zm-4.311-8.774c.746 2.243.346 4.7-.12 6.416-.28 1.07-.666 2.11-1.15 3.105a1.667 1.667 0 1 1-2.984-1.488c.387-.8.694-1.634.917-2.493.378-1.387.568-2.892.276-4.125l-.101-.36a1.666 1.666 0 1 1 3.162-1.055Zm9.024 4.063a1.667 1.667 0 0 1 0 2.357l-1.178 1.178a1.661 1.661 0 0 1-2.377.021 1.671 1.671 0 0 1-.353-1.837 1.67 1.67 0 0 1 .373-.54l1.179-1.179a1.667 1.667 0 0 1 2.356 0Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52,
    x2: 52,
    y1: 0,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 104,
    x2: -20.448,
    y1: 0,
    y2: 39.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 66.738,
    x2: 29.875,
    y1: 35.481,
    y2: 46.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeIconNew);
export default __webpack_public_path__ + "static/media/file-type-icon-new.5128642b8b259aafe9342354a918830b.svg";
export { ForwardRef as ReactComponent };